// i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resources from './translation';

const getLanguage = () => {
  const language = localStorage.getItem('page-lang');
  if(language==="ar"){document.documentElement.dir="rtl"}
  else{document.documentElement.dir="ltr"}
  return language || 'en';
};

// Initialize i18n
i18n.use(initReactI18next).init({
  resources,
  lng: getLanguage(),
  fallbackLng: 'en',  
  interpolation: {
    escapeValue: false, 
  },
});

export default i18n;
